import { Injectable }     from '@angular/core';
import { CanActivate, Router }    from '@angular/router';
import { TicketService } from './Ticket/Services/ticket.service';

@Injectable()
export class RouteGuard implements CanActivate {

    client: {};

    constructor(private router: Router, private ticketService: TicketService) {
    }

    canActivate() {

        return new Promise(resolve => {

            this.ticketService.getClientData().subscribe(result => {
                this.client = result;
                this.ticketService.client = result;

                if (result.error === true) {
                    this.router.navigate(['/404']);
                    resolve(false);
                } else {
                    localStorage.setItem("configured", 'true');
                }
                resolve(true);
            }, error => {

                this.router.navigate(['/500']);
                resolve(false);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/route-guard.service.ts